module.exports = __webpack_public_path__ + "img/passio-bg.f5e07741.png";